export default __webpack_public_path__ + "static/media/logo.a9b37093.png";